function fetchNews(obj) {
  const isHide = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('news-hide');
  if (obj && obj[0] && !isHide) {
    const today = new Date();
    today.setDate(today.getDate() - 90);
    const pastDate = new Date(today - ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
    const date = new Date(obj[0].date);

    if (date >= pastDate) {
      const year = date.getFullYear();
      const month = ('00' + (date.getMonth() + 1)).slice(-2);
      const day = ('00' + date.getDate()).slice(-2);
      $('.js-news-text')[0].innerText = `${year}.${month}.${day} ${obj[0].title.rendered}`;
      $('.js-news-link')[0].href = obj[0].link;

      window.onload = function () {
        $(window).trigger('newsShow');
      };
    }
  }

  $('.js-news-close').on('click', function() {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('news-hide', 'true');
    }
  });
}
